import type { JSX } from 'react'
import { Link } from 'react-router'
import { api, call } from '@/api/client'
import { useQuery } from '@/api/query'
import { summariseSendWindow } from '@/settings/send-window/summary'
import { ErrorState, Loading } from '@/ui/states'

/**
 * The send window as Account health shows it: read-only, with the way to the
 * one place it is edited.
 *
 * Settings consolidation (2026-09-15). The form that lived here (C1, then
 * P-HLTH-07's save-on-change version) never closed, because there was no
 * read-only state to close to. It is `/settings/send-window` now; this card
 * says what the window is and where to change it.
 */
export function SendWindowSummary(): JSX.Element {
  const automation = useQuery((signal) => call(() => api.GET('/api/v1/automation', { signal })), [])

  return (
    <div className="ar-card" id="send-window">
      <div className="ar-card__header">
        <h2>Send window</h2>
        <span className="ar-card__spacer" />
        <Link className="ar-btn ar-btn--ghost ar-btn--sm" to="/settings/send-window">
          Change in Settings →
        </Link>
      </div>
      <div className="ar-card__body">
        {automation.state.status === 'loading' ? (
          <Loading label="Loading your send window" lines={1} />
        ) : null}
        {automation.state.status === 'error' ? (
          <ErrorState
            failure={automation.state.failure}
            title="Could not load your send window"
            onRetry={automation.refetch}
          />
        ) : null}
        {automation.state.status === 'ready' ? (
          <p style={{ margin: 0 }}>{summariseSendWindow(automation.state.data)}</p>
        ) : null}
      </div>
    </div>
  )
}
